
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthbr9lps4JqgQr6IQfrNYUxkcSz6jYGoDDeZI7CNR_yBUMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_936qprUC6ITao7rP_45PTNzo_fqqBc1IxNA2cIjYwhvmBaQMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue?macro=true";
import { default as port_45parkingRLd5IIb_45EvLpVchuZfIXLo_45QfQV3v9VsMwKeFkBjNCYMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45hotelsJai063W7dcrXVAs7wOW3P3uMx0SDCa8oGblMAWl45TsMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue?macro=true";
import { default as airport_45parkinglPcygn5vhfmZdB3xw_45_45YuCvWxN7l0f7Q_45EW_DgJ_45YBkMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93qPGu1yavRmlzVLgH_Tv4Dw5F3PugTU1EKRxyDHFUj0AMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93lojzPOKmz2Hzgu9ApqSLELCA940QlSR_EOZI0oEu4dgMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as port_45hotels_45with_45parkingxny8U6RviOhlmK1ubwUSQAlgro8UEqDNgVFV9_Ij_45tEMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingyfX6iGnWR_nyngzFF5mEU267nXfusjoft6amTzfDUO0Meta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93gpcJMcfIibKfMJT8JAtpvxKlHnCfM9H2kYt0XGFGNqoMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubXQZQ3QhK43BvataW6R9uT3zRdyUXAgoH3nIR4kwm1zcMeta } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.0.15_db0@0.3.2_es_02faacb384bf43dc81dfa2d8b50dca67/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubXQZQ3QhK43BvataW6R9uT3zRdyUXAgoH3nIR4kwm1zc } from "/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@24.0.15_db0@0.3.2_es_02faacb384bf43dc81dfa2d8b50dca67/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/_base/pages/[...slug].vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-hotels___en",
    path: "/:IATA()/airport-hotels",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3150524121/src/bitbucket.org/magusa/cavu-workspaces/apps/psf/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: component_45stubXQZQ3QhK43BvataW6R9uT3zRdyUXAgoH3nIR4kwm1zcMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubXQZQ3QhK43BvataW6R9uT3zRdyUXAgoH3nIR4kwm1zc
  }
]